<div class="row">
  <div class="col-md-12">
    <nb-card>
      <nb-card-header>{{ 'tytul.ewidencja-ryczaltu' | translate }}</nb-card-header>  
      <nb-card-body>
        <section >
          <span>{{ 'akcja.wybierz-okres' | translate }}:</span>
        </section>
        <section class="mt-2 ml-3">
          <ngx-zakres-dat (zmianaZakresu)="onChangeZmianaZakresu($event)"></ngx-zakres-dat>
        </section>

        <section class="mt-2">
          <button class="mr-2" [disabled]="!dane" nbButton size="small" (click)="exportPdf()"><nb-icon icon="cloud-download-outline"></nb-icon>PDF</button>
          <button nbButton size="small" (click)="wyswietlanieFiltrow = !wyswietlanieFiltrow">{{ wyswietlanieFiltrow ? ('akcja.ukryj-filtry' | translate) : ('akcja.pokaz-filtry' | translate) }}</button>
        </section>

        <!-- Widok desktopowy - tabela -->
        <div class="desktop-view">
          <ngx-datatable
            #table
            class="bootstrap"
            [rows]="dane"
            [summaryRow]="true"
            [summaryPosition]="'bottom'"
            [headerHeight]="55"
            [rowHeight]="45"
            [footerHeight]="50"
            [columnMode]="'standard'"
            [scrollbarH]=true
            [messages]="komunikatyTabeli"
            [limit]="15"
            ngxDatatableEmptyRow>
          
          <ngx-datatable-column
            headerClass="font-weight-bold" 
            prop="liczbaPorzadkowa"
            name="{{ 'etykieta.lp' | translate }}"
            cellClass="text-center"
            [width]="50"
            [summaryFunc]=null>
          </ngx-datatable-column>

          <ngx-datatable-column 
            prop="dataWpisu"
            name="{{ 'etykieta.data-wpisu' | translate }}"
            cellClass="text-center"
            [width]="150"
            [headerTemplate]="hdrTpl">
          </ngx-datatable-column>

          <ngx-datatable-column 
            prop="dataUzyskaniaPrzychodu"
            name="{{ 'etykieta.data-przychodu' | translate }}"
            cellClass="text-center"
            [width]="150"
            [headerTemplate]="hdrTpl">
          </ngx-datatable-column>

          <ngx-datatable-column 
            prop="numerDowoduKsiegowego"
            name="{{ 'etykieta.nr-dowodu-ksiegowego' | translate }}"
            cellClass="text-center"
            [headerTemplate]="hdrTpl"
            [width]="200">
          </ngx-datatable-column>

          <ngx-datatable-column 
            headerClass="font-weight-bold" 
            prop="przychod170"
            name="17%"
            cellClass="text-right"
            [width]="100"
            [summaryFunc]="sumaKwota"
            *ngIf="czyKolumna170()">
            <ng-template let-value="value" ngx-datatable-cell-template>
                {{value | kwota}}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column 
            headerClass="font-weight-bold" 
            prop="przychod150"
            name="15%"
            cellClass="text-right"
            [width]="100"
            [summaryFunc]="sumaKwota"
            *ngIf="czyKolumna150()">
            <ng-template let-value="value" ngx-datatable-cell-template>
                {{value | kwota}}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column 
            headerClass="font-weight-bold" 
            prop="przychod140"
            name="14%"
            cellClass="text-right"
            [width]="100"
            [summaryFunc]="sumaKwota"
            *ngIf="czyKolumna140()">
            <ng-template let-value="value" ngx-datatable-cell-template>
                {{value | kwota}}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column 
            headerClass="font-weight-bold" 
            prop="przychod125"
            name="12,5%"
            cellClass="text-right"
            [width]="100"
            [summaryFunc]="sumaKwota"
            *ngIf="czyKolumna125()">
            <ng-template let-value="value" ngx-datatable-cell-template>
                {{value | kwota}}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column 
            headerClass="font-weight-bold" 
            prop="przychod120"
            name="12%"
            cellClass="text-right"
            [width]="100"
            [summaryFunc]="sumaKwota"
            *ngIf="czyKolumna120()">
            <ng-template let-value="value" ngx-datatable-cell-template>
                {{value | kwota}}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column 
            headerClass="font-weight-bold" 
            prop="przychod100"
            name="10%"
            cellClass="text-right"
            [width]="100"
            [summaryFunc]="sumaKwota"
            *ngIf="czyKolumna100()">
            <ng-template let-value="value" ngx-datatable-cell-template>
                {{value | kwota}}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column 
            headerClass="font-weight-bold" 
            prop="przychod085"
            name="8,5%"
            cellClass="text-right"
            [width]="100"
            [summaryFunc]="sumaKwota"
            *ngIf="czyKolumna085()">
            <ng-template let-value="value" ngx-datatable-cell-template>
                {{value | kwota}}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column 
            headerClass="font-weight-bold" 
            prop="przychod055"
            name="5,5%"
            cellClass="text-right"
            [width]="100"
            [summaryFunc]="sumaKwota"
            *ngIf="czyKolumna055()">
            <ng-template let-value="value" ngx-datatable-cell-template>
                {{value | kwota}}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column 
            headerClass="font-weight-bold" 
            prop="przychod030"
            name="3%"
            cellClass="text-right"
            [width]="100"
            [summaryFunc]="sumaKwota"
            *ngIf="czyKolumna030()">
            <ng-template let-value="value" ngx-datatable-cell-template>
                {{value | kwota}}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column 
            headerClass="font-weight-bold" 
            prop="przychod020"
            name="2%"
            cellClass="text-right"
            [width]="100"
            [summaryFunc]="sumaKwota"
            *ngIf="czyKolumna020()">
            <ng-template let-value="value" ngx-datatable-cell-template>
                {{value | kwota}}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column 
            headerClass="font-weight-bold" 
            prop="przychodRazem"
            name="{{ 'etykieta.przychod-razem-ryczalt' | translate }}"
            cellClass="text-right"
            [width]="140"
            [summaryFunc]="sumaKwota">
            <ng-template let-value="value" ngx-datatable-cell-template>
                {{value | kwota}}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column 
            prop="uwagi"
            name="{{ 'etykieta.uwagi' | translate }}"
            cellClass="text-center"
            [headerTemplate]="hdrTpl"
            [width]="140">
          </ngx-datatable-column>

          </ngx-datatable>
        </div>

        <!-- Widok mobilny - kafelki -->
        <div class="mobile-view">
          <!-- Filtr dla widoku mobilnego -->
          <div class="mobile-filter mb-3" *ngIf="wyswietlanieFiltrow">
            <input
              nbInput
              fullWidth
              type="search"
              placeholder="{{ 'etykieta.szukaj' | translate }}"
              (input)="updateFilterMobile($event)"
            />
          </div>

          <!-- Kafelki z danymi -->
          <div class="row">
            <div class="col-12 mb-3" *ngFor="let item of dane; let i = index">
              <nb-card>
                <nb-card-header>
                  <div class="d-flex justify-content-between align-items-center">
                    <span class="font-weight-bold">{{ item.numerDowoduKsiegowego }}</span>
                    <span class="text-muted">#{{ item.liczbaPorzadkowa }}</span>
                  </div>
                </nb-card-header>
                <nb-card-body>
                  <div class="row mb-2">
                    <div class="col-6">
                      <div class="stat-label">{{ 'etykieta.data-wpisu' | translate }}</div>
                      <div class="stat-value">{{ item.dataWpisu }}</div>
                    </div>
                    <div class="col-6">
                      <div class="stat-label">{{ 'etykieta.data-przychodu' | translate }}</div>
                      <div class="stat-value">{{ item.dataUzyskaniaPrzychodu }}</div>
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-12">
                      <div class="stat-label">{{ 'etykieta.przychod-razem-ryczalt' | translate }}</div>
                      <div class="stat-value text-success font-weight-bold">{{ item.przychodRazem | kwota }}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4" *ngIf="item.przychod170 > 0">
                      <div class="stat-label">17%</div>
                      <div class="stat-value text-primary">{{ item.przychod170 | kwota }}</div>
                    </div>
                    <div class="col-4" *ngIf="item.przychod150 > 0">
                      <div class="stat-label">15%</div>
                      <div class="stat-value text-primary">{{ item.przychod150 | kwota }}</div>
                    </div>
                    <div class="col-4" *ngIf="item.przychod140 > 0">
                      <div class="stat-label">14%</div>
                      <div class="stat-value text-primary">{{ item.przychod140 | kwota }}</div>
                    </div>
                    <div class="col-4" *ngIf="item.przychod125 > 0">
                      <div class="stat-label">12,5%</div>
                      <div class="stat-value text-primary">{{ item.przychod125 | kwota }}</div>
                    </div>
                    <div class="col-4" *ngIf="item.przychod120 > 0">
                      <div class="stat-label">12%</div>
                      <div class="stat-value text-primary">{{ item.przychod120 | kwota }}</div>
                    </div>
                    <div class="col-4" *ngIf="item.przychod100 > 0">
                      <div class="stat-label">10%</div>
                      <div class="stat-value text-primary">{{ item.przychod100 | kwota }}</div>
                    </div>
                    <div class="col-4" *ngIf="item.przychod085 > 0">
                      <div class="stat-label">8,5%</div>
                      <div class="stat-value text-primary">{{ item.przychod085 | kwota }}</div>
                    </div>
                    <div class="col-4" *ngIf="item.przychod055 > 0">
                      <div class="stat-label">5,5%</div>
                      <div class="stat-value text-primary">{{ item.przychod055 | kwota }}</div>
                    </div>
                    <div class="col-4" *ngIf="item.przychod030 > 0">
                      <div class="stat-label">3%</div>
                      <div class="stat-value text-primary">{{ item.przychod030 | kwota }}</div>
                    </div>
                    <div class="col-4" *ngIf="item.przychod020 > 0">
                      <div class="stat-label">2%</div>
                      <div class="stat-value text-primary">{{ item.przychod020 | kwota }}</div>
                    </div>
                  </div>
                  <div class="row mt-2" *ngIf="item.uwagi">
                    <div class="col-12">
                      <div class="stat-label">{{ 'etykieta.uwagi' | translate }}</div>
                      <div class="stat-value">{{ item.uwagi }}</div>
                    </div>
                  </div>
                </nb-card-body>
              </nb-card>
            </div>
          </div>

          <!-- Podsumowanie dla widoku mobilnego -->
          <nb-card accent="info" *ngIf="dane && dane.length > 0">
            <nb-card-header>
              <span class="font-weight-bold">{{ 'etykieta.podsumowanie' | translate }}</span>
            </nb-card-header>
            <nb-card-body>
              <div class="row mb-2">
                <div class="col-12">
                  <div class="stat-label">{{ 'etykieta.przychod-razem-ryczalt' | translate }}</div>
                  <div class="stat-value text-success font-weight-bold">{{ sumaPrzychodRazem() | kwota }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-4" *ngIf="czyKolumna170()">
                  <div class="stat-label">17%</div>
                  <div class="stat-value text-primary">{{ sumaPrzychod170() | kwota }}</div>
                </div>
                <div class="col-4" *ngIf="czyKolumna150()">
                  <div class="stat-label">15%</div>
                  <div class="stat-value text-primary">{{ sumaPrzychod150() | kwota }}</div>
                </div>
                <div class="col-4" *ngIf="czyKolumna140()">
                  <div class="stat-label">14%</div>
                  <div class="stat-value text-primary">{{ sumaPrzychod140() | kwota }}</div>
                </div>
                <div class="col-4" *ngIf="czyKolumna125()">
                  <div class="stat-label">12,5%</div>
                  <div class="stat-value text-primary">{{ sumaPrzychod125() | kwota }}</div>
                </div>
                <div class="col-4" *ngIf="czyKolumna120()">
                  <div class="stat-label">12%</div>
                  <div class="stat-value text-primary">{{ sumaPrzychod120() | kwota }}</div>
                </div>
                <div class="col-4" *ngIf="czyKolumna100()">
                  <div class="stat-label">10%</div>
                  <div class="stat-value text-primary">{{ sumaPrzychod100() | kwota }}</div>
                </div>
                <div class="col-4" *ngIf="czyKolumna085()">
                  <div class="stat-label">8,5%</div>
                  <div class="stat-value text-primary">{{ sumaPrzychod085() | kwota }}</div>
                </div>
                <div class="col-4" *ngIf="czyKolumna055()">
                  <div class="stat-label">5,5%</div>
                  <div class="stat-value text-primary">{{ sumaPrzychod055() | kwota }}</div>
                </div>
                <div class="col-4" *ngIf="czyKolumna030()">
                  <div class="stat-label">3%</div>
                  <div class="stat-value text-primary">{{ sumaPrzychod030() | kwota }}</div>
                </div>
                <div class="col-4" *ngIf="czyKolumna020()">
                  <div class="stat-label">2%</div>
                  <div class="stat-value text-primary">{{ sumaPrzychod020() | kwota }}</div>
                </div>
              </div>
            </nb-card-body>
          </nb-card>
        </div>

        <ng-template #hdrTpl let-column="column" let-sort="sortFn">
          <span class="font-weight-bold" (click)="sort()">{{ column.name }}</span>
          <span [hidden] = "!wyswietlanieFiltrow">
            <br/>
            <input
              nbInput
              fieldSize="small"
              type="search"
              class="w-75"
              (input)="updateFilter($event, column.prop)"
            />
          </span>
        </ng-template>
      </nb-card-body>
    </nb-card>
  </div>
</div>
